import useSEO from "@/lib/useSEO";
import { Truck, Cog, ShieldCheck, HeartHandshake, Wrench } from "lucide-react";

const VALUES = [
  { i: Wrench, t: "Practical Solutions", d: "Focus on finding the actual cause of faults rather than replacing unnecessary parts." },
  { i: ShieldCheck, t: "Reliable Support", d: "Clear communication and professional service." },
  { i: Truck, t: "Mobile Capability", d: "Service and repairs at the customer's site wherever practical." },
  { i: Cog, t: "Industry Experience", d: "Experience with multiple forklift manufacturers and machine types." },
  { i: HeartHandshake, t: "Long-term Relationships", d: "Help businesses maintain their equipment rather than only responding when something breaks." },
];

export default function About() {
  useSEO({
    title: "About Forkfix — Brisbane Forklift Specialists",
    description: "Forkfix is a Brisbane forklift service, repair, hire and sales business. Mobile technicians, multi-brand experience across Queensland.",
    canonical: "https://forkfix.net/about-forkfix",
  });
  return (
    <div>
      <section className="bg-[#111111] text-white">
        <div className="max-w-7xl mx-auto px-6 py-20 ff-diagonal-bg">
          <div className="text-xs uppercase tracking-widest text-[#D71920] font-bold">About Forkfix</div>
          <h1 className="font-display text-5xl md:text-7xl uppercase mt-3">Brisbane's forklift specialist</h1>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-6 py-16 space-y-5 text-[#333] text-lg leading-relaxed">
        <p>Forkfix is a Brisbane-based forklift service, repair, hire and sales business focused on keeping material-handling equipment operating safely and reliably.</p>
        <p>We provide mobile forklift servicing and repairs directly at customer sites, helping businesses minimise downtime and avoid unnecessary equipment transport.</p>
        <p>Our experience covers a wide range of LPG, diesel and electric forklifts, reach trucks and other material-handling equipment.</p>
        <p>Whether you operate a single forklift or a larger fleet, Forkfix provides practical technical support tailored to your operation.</p>
      </section>
      <section className="bg-[#f4f4f4] py-16">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="ff-accent-heading font-display text-4xl uppercase mb-8">Our approach</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#e5e5e5] border border-[#e5e5e5]">
            {VALUES.map(({ i: I, t, d }) => (
              <div key={t} className="bg-white p-8"><I className="w-7 h-7 text-[#D71920]" /><h3 className="font-display text-2xl uppercase mt-4">{t}</h3><p className="text-sm text-[#555] mt-2">{d}</p></div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
